//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmZpusobVyrizeniDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-02-08                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.11.2
//AdtGeneratorConfig:[ T:(sslszvs) GID:(Web.Set.Des.Ts) V1:(zp_vyriz,aktivita,dat_zmena,zmenu_prov,zp_vyriz_txt,priz_cj_only,priz_vycet,ico) V2:() K1:() K2:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamZastupDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamAdmZpusobVyrizeniDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - zp_vyriz */
            public zp_vyriz: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmZpusobVyrizeniListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmZpusobVyrizeniDesigner>): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true);

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmZpusobVyrizeniDesigner>): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        /**
         * SeznamAdmZpusobVyrizeniDesignerInit
         * 
         * @param {GContentType<SeznamAdmZpusobVyrizeniDesigner>} that
         */
        static SeznamAdmZpusobVyrizeniDesignerInit(that: GContentType<SeznamAdmZpusobVyrizeniDesigner>) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);

            that.view = new Gordic.Isl.View(that.isl.AdmZpusobVyrizeni.list(), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamAdmZpusobVyrizeniDesignerInit

    }
}
